import type { LucideIcon } from 'lucide-react';

export enum StepperIndustryKey {
	AutoDetect = 'autoDetect',
	Automotive = 'automotive',
	Catering = 'catering',
	CleaningServices = 'cleaningServices',
	ConstructionContracting = 'constructionContracting',
	ConsultingProfessionalServices = 'consultingProfessionalServices',
	DentalOrthodontics = 'dentalOrthodontics',
	DesignPhotographyCreative = 'designPhotographyCreative',
	ECommerceRetail = 'eCommerceRetail',
	EducationNonprofit = 'educationNonprofit',
	EventsEntertainmentTicketing = 'eventsEntertainmentTicketing',
	FinancialServices = 'financialServices',
	FuneralServices = 'funeralServices',
	GeneralReceptionist = 'generalReceptionist',
	Healthcare = 'healthcare',
	HomeServices = 'homeServices',
	HospitalityHotels = 'hospitalityHotels',
	Insurance = 'insurance',
	InvestmentCapital = 'investmentCapital',
	LegalLawFirms = 'legalLawFirms',
	LogisticsTransportation = 'logisticsTransportation',
	ManufacturingIndustrialServices = 'manufacturingIndustrialServices',
	MarketingMedia = 'marketingMedia',
	Other = 'other',
	PetServices = 'petServices',
	PropertyManagement = 'propertyManagement',
	RealEstate = 'realEstate',
	Restaurants = 'restaurants',
	TechnologyIt = 'technologyIt',
	TourismTravel = 'tourismTravel',
	WellnessBeautyFitnessSports = 'wellnessBeautyFitnessSports'
}

export enum StepperIndustryValue {
	Automotive = 'automotive_industry',
	Beauty = 'beauty_industry',
	Catering = 'catering_industry',
	Cleaning = 'cleaning_industry',
	Construction = 'construction_industry',
	Dental = 'dental_industry',
	ECommerce = 'ecommerce_industry',
	Education = 'education_industry',
	Financial = 'financial_industry',
	Funeral = 'funeral_industry',
	General = 'general_industry',
	Healthcare = 'healthcare_industry',
	HomeService = 'home_service_industry',
	Hospitality = 'hospitality_industry',
	Insurance = 'insurance_industry',
	Investment = 'investment_industry',
	Legal = 'legal_industry',
	Logistics = 'logistics_industry',
	Manufacturing = 'manufacturing_industry',
	PetServices = 'pet_services_industry',
	PropertyManagement = 'property_management_industry',
	RealEstate = 'real_estate_industry',
	Restaurant = 'restaurant_industry',
	Sales = 'sales_industry',
	Technology = 'technology_industry'
}

export enum StepperIndustryGroupKey {
	Primary = 'primary',
	Additional = 'additional'
}

export enum StepperAgentGender {
	Auto = 'auto',
	Female = 'female'
}

export enum StepperSetupStepKey {
	TellAboutBusiness = 'tellAboutBusiness',
	ExtractWebsiteContent = 'extractWebsiteContent',
	CustomizeGreeting = 'customizeGreeting',
	CallSummariesTransfers = 'callSummariesTransfers',
	MakeTestCall = 'makeTestCall'
}

export enum StepperSetupStepStatus {
	Active = 'active',
	Completed = 'completed',
	Upcoming = 'upcoming'
}

export interface StepperIndustryOption {
	icon?: LucideIcon;
	iconClassName?: string;
	key: StepperIndustryKey;
}

export interface StepperIndustryGroup {
	industries: StepperIndustryOption[];
	key: StepperIndustryGroupKey;
}

export interface StepperSetupStep {
	key: StepperSetupStepKey;
}

export interface StepperOnboardingFormValues {
	agentName: string;
	agentPhoneNumber: string;
	businessName: string;
	businessPhoneNumber: string;
	createdCustomerIdn: string;
	industry: StepperIndustryKey;
	websiteUrl: string;
	greetingPhrase: string;
	managerEmail: string;
	managerFullName: string;
	managerPhone: string;
}
